import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getReleasesListEffect } from 'app/store/Releases/effects';
import { LoadingState } from 'types/enums';
import { isLoading } from 'app/utils/utils';
import {
  getDeleteReleaseLink,
  getReleases,
} from 'app/store/Releases/selectors';
import { useIsMounted } from 'app/utils/hooks';
import { ReleaseListComponent } from './ReleaseListComponent';

export const ReleaseList = () => {
  const dispatch = useAppDispatch();
  const releases = useAppSelector(getReleases);
  const canDeleteRelease = Boolean(useAppSelector(getDeleteReleaseLink));
  const [loadingState, setLoadingState] = useState(LoadingState.PRISTINE);
  const isMounted = useIsMounted();

  useEffect(() => {
    const fetchResources = async () => {
      try {
        setLoadingState(LoadingState.FETCHING);
        await dispatch(getReleasesListEffect({})).unwrap();
        if (isMounted()) {
          setLoadingState(LoadingState.FETCHED);
        }
      } catch (e) {
        if (isMounted()) {
          setLoadingState(LoadingState.ERROR);
        }
      }
    };
    fetchResources();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted]);

  return (
    <ReleaseListComponent
      releases={releases}
      loading={isLoading(loadingState)}
      canDeleteRelease={canDeleteRelease}
    />
  );
};
